import type { MembershipEventDataSource } from '~/api/data-source/membership-event';
import { membershipEventDataSource } from '~/api/data-source/membership-event';
import type { MembershipEventResponse } from '~/api/model';
import { membershipEventResponseSchema, parseModel } from '~/api/model';

export interface MembershipEventRepository {
  getPlusMembershipEvent(): Promise<MembershipEventResponse>;
}

export class MembershipEventRepositoryImpl
  implements MembershipEventRepository
{
  // eslint-disable-next-line no-useless-constructor
  constructor(
    private readonly dataSource: MembershipEventDataSource = membershipEventDataSource,
  ) {}

  async getPlusMembershipEvent() {
    const response = await this.dataSource.getPlusMembershipEvent();
    return parseModel(
      membershipEventResponseSchema,
      response,
      'MembershipEventResponse',
    );
  }
}

export const membershipEventRepository = new MembershipEventRepositoryImpl();
